import { Injectable } from '@angular/core'
import { User } from '../_models'
import { UserService } from './user.service'
import { AnalyticsService } from './analytics.service'
import { firstValueFrom } from 'rxjs'
import { PreviousUserTrackingService } from './previous-user-tracking.service'
import { LocalStorageAccessService } from './local-storage-access.service'
import { DeaAttemptedTrackingService } from './dea-attempted-tracking.service'
@Injectable({
    providedIn: 'root',
})
export class LoginSignupUtilService {
    constructor(
        private userService: UserService,
        private analyticsService: AnalyticsService,
        private previousUserTrackingService: PreviousUserTrackingService,
        private localStorageAccessService: LocalStorageAccessService,
        private deaAttemptedTrackingService: DeaAttemptedTrackingService,
    ) {}

    setComingFromSignUp(value: boolean) {
        if (!value) {
            this.localStorageAccessService.removeItem('comingFromSignUp')
        } else {
            this.localStorageAccessService.setItem('comingFromSignUp', 't')
        }
    }

    getComingFromSignup(): boolean {
        return this.localStorageAccessService.getItem('comingFromSignUp') === 't'
    }

    async markOnboardingComplete(user: User) {
        user.onboard = true
        const previousUserId = await this.previousUserTrackingService.getPreviousUserId()
        const deaAttempted = this.deaAttemptedTrackingService.hasDeaAttempted()
        await firstValueFrom(this.userService.update(user, null, previousUserId, deaAttempted))
        this.analyticsService.logOnboardingComplete()
        this.deaAttemptedTrackingService.clearDeaAttempted()
    }
}
